import { useTour } from '@reactour/tour';
import { useNavigate, useParams, useMatches, createSearchParams, useSearchParams, useLocation } from 'react-router';


export const withRouter = (Component) => {
  const Wrapper = (props) => {
    const navigate = useNavigate();
    const match = useMatches();
    const params = useParams();
    const [searchParams, setSearchParams] = useSearchParams();
    const tour = useTour();
    const location = useLocation();
    
    function navigateNg(params){
        const para = "?" + createSearchParams(params?.search).toString();
        navigate({
            pathname: params?.pathname,
            search: para,
            state: params.state
        });
    }
    return (
      <Component
        searchparams={searchParams}
        setSearchParams={setSearchParams}
        params={params}
        match={match}
        tour={tour}
        navigate={navigateNg}
        location={location}
        {...props}
        />
    );
  };
  
  return Wrapper;
};